import React, { useContext } from "react";
import styled from "styled-components";
import { developAxios } from "../axios.config";
import { WeeklyContext } from "../Context/WeeklyContext";
import { Link } from "react-router-dom";
import { AllCourseContext } from "../Context/AllCourse";
const Main = styled.div`
	display: flex;
	flex-direction: Column;
`;
const Section = styled.div`
	margin: auto;
`;

const Button = styled.button`
	height: 50px;
	width: 100px;
	background-color: grey;
	border-radius: 5px;
	cursor: pointer;
	color: white;
`;

const CreateWeeklyContent = () => {
	const { week, setWeek, topic, setTopic, courseId, setCourseId } =
		useContext(WeeklyContext);
	const { course } = useContext(AllCourseContext);

	const handleSubmit = async (e) => {
		e.preventDefault();
		await developAxios(localStorage.getItem("token"))
			.post(
				`/pd-online/createWeeklyContent`,
				{
					week: week,
					topic: topic,
					courseId: courseId,
				},

				{
					headers: {
						Authorization: "token",
					},
				}
			)
			.then(({ data }) => {
				console.log(data);
			})
			.catch((e) => {
				console.log(e);
			});
	};
	const handleChange = (e) => {
		setCourseId(e.target.value);
	};
	console.log(course);

	const list = [
		"Arrays",
		"Strings",
		"Linked List",
		"Stacks",
		"Queues",
		"Trees",
		"Graphs",
		"Sorting",
		"Searching",
		"Recursion",
		"Dynamic Programming",
		"Loops",
	];

	const handleTopic = (e) => {
		setTopic(e.target.value);
	};
	return (
		<Main>
			<Section>
				<form onSubmit={handleSubmit}>
					<input
						className="  block
          w-full
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding bg-no-repeat
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          mb-5
          mt-5
         1/2 w-
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
						aria-label="Default select example"
						placeholder="Week"
						value={week}
						onChange={(e) => setWeek(e.target.value)}
						type="text"
					/>

					<select
						className="  block
          w-full
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding bg-no-repeat
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          mb-5
         1/2 w-
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
						aria-label="Default select example"
						onChange={handleTopic}
					>
						{list.map((ele) => {
							return <option> {ele}</option>;
						})}
					</select>

					<select
						className="  block
          w-full
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding bg-no-repeat
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          mb-5
         1/2 w-
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
						aria-label="Default select example"
						onChange={handleChange}
					>
						{course.map((ele) => {
							return <option value={ele._id}> {ele.name}</option>;
						})}
					</select>
					<button
						className="rounded-full
          bg-sky-500 hover:bg-sky-700 py-2 px-4 text-stone-50	mt-5 "
						name="submit"
						type="submit"
					>
						Create
					</button>
				</form>
			</Section>
		</Main>
	);
};

export default CreateWeeklyContent;
